

import dayjs from 'dayjs'
import COSsdk from 'cos-js-sdk-v5';
import { getCosConfig, getCosConfigBase } from '@/api';
import utils from '@/libs/utils'

export class Cos {
    #COS=null;//实例
    #endTime = Date.now();//结束时间
    prefix;// 一级路径
    path;//二级文件路劲
    bucket;
    region;
    basePrefix;
    host;
    type; // 区分需要 广州的 存储桶 还是北京的 存储桶
    static _promise = null;//节流 防止重复的触发
    constructor({ prefix,  path, type }) {
        this.prefix = prefix;
        this.path = path;
        this.type = type;
        // this.#getCOS()
    }
    #getCOS() {
        if (Cos._promise) {
            return Cos._promise;
        };
        const now = Date.now()
        // 超时或者不存在  都要重新获取
        console.log(this.#COS, Date.now(), this.#endTime, Date.now()>this.#endTime);
        
        if (!this.#COS || now>this.#endTime) {
            Cos._promise = new Promise(async (res, rej)=> {
                try {
                    const base = await getCosConfigBase({ type: this.type });
                    const { bucket,region, prefix } = base.data;
                    this.bucket = bucket;
                    this.region = region;
                    this.basePrefix = prefix;
                    
                    const config = await getCosConfig({
                        action:'name/cos:PutObject',//
                        bucket,// 
                        region,// 
                        prefix:`${prefix}${this.prefix}`,//  
                    })
                    const { credentials, startTime, expiredTime, img_host } = config.data;
                    this.host = img_host;
                    const COS = new COSsdk({
                        FileParallelLimit: 10,
                        getAuthorization: function (options, callback) {
                            callback({
                                TmpSecretId: credentials.tmpSecretId,
                                TmpSecretKey: credentials.tmpSecretKey,
                                XCosSecurityToken: credentials.sessionToken,
                                StartTime: startTime,
                                ExpiredTime: expiredTime,
                            });
                        },
                    });
                    this.#endTime = expiredTime*1000;
                    this.#COS = COS;
                    console.log(COS, 'COS');
                    res();
                } catch (error) {
                    console.log(error, 'cos错误');
                    rej(error)
                };
                Cos._promise.finally(()=> {
                    Cos._promise = null;
                })
            });
           return Cos._promise;
        }else {
            // 不需要获取则直接过
            return Promise.resolve()
        }
       
    }
    // putObject 上传文件的方法
    async putObject(file, options = {}) {
        await this.#getCOS();
        const { bucket,region, basePrefix, host } = this;
        const result = await this.#COS.putObject({
            Bucket: bucket, /* 必须 */
            Region: region,    /* 必须 */
            Key: `${ basePrefix }${this.path}${this.getPath()}${this.#getFileName(file)}`, /* 必须 */
            Body: file, // 上传文件对象
            ...options,
        });
        const location = result.Location;
        const path = location.split(basePrefix).pop();
        return {
            ...result,
            name: file.name,
            full_path: `${host}${path}`,
            path,
            region: this.region
        }
    }
    // 生成日期随机路径
    getPath() {
        const datePath = dayjs().format('YYYY-MM-DD');
        const uid = utils.randomString(20);
        return `/${datePath}/${uid}/`
    }
    cancelTask(id) {
        return this.#COS.cancelTask(id)
    }
    #getFileName(file) {
        const name = file.name;
        return `${utils.randomString(20)}${name.substring(name.lastIndexOf('.'))}`;
    };
};
